// lib/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Usa process.env para acceder a las variables de entorno en CRA
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
